import React, { useMemo } from "react";
import styled from "styled-components";
import EventDetailsTable from "components/events/events/EventDetailsTable";
import { eventTypeAttribute } from "components/events/events/ColumnRenderers";
import useEventsAdditionalData from "components/events/ReplaySearchSidebar/hooks/useEventsAdditionalData";
import useEventById from "hooks/useEventById";
import { Spinner } from "components/common";
import ExpandableSection from "components/events/ReplaySearchSidebar/ExpandableSection";
import EventDefinitionInfoTable from "components/event-definitions/replay-search/EventDefinitionInfoTable";
import ReplaySearchContext from "components/event-definitions/replay-search/ReplaySearchContext";
const attributesList = [
  {
    id: "timestamp",
    title: "Timestamp",
    type: "DATE"
  },
  {
    id: "alert",
    title: "Type"
  },
  {
    id: "message",
    type: "STRING",
    title: "Message"
  }
];
const WordBreak = styled.span`
  word-break: break-all;
`;
export const WordBreakRenderer = (val) => /* @__PURE__ */ React.createElement(WordBreak, null, val);
const attributesRenderers = {
  alert: eventTypeAttribute,
  message: { renderCell: WordBreakRenderer }
};
const GeneralEventSideBar = ({ alertId, definitionId }) => {
  const { data: eventData, isLoading: isLoadingEvent } = useEventById(alertId);
  const resolvedDefinitionId = definitionId != null ? definitionId : eventData == null ? void 0 : eventData.event_definition_id;
  const { meta, isLoadingEventDefinition } = useEventsAdditionalData({
    eventData,
    definitionId: resolvedDefinitionId
  });
  const replaySearchContext = useMemo(
    () => ({
      alertId,
      definitionId: resolvedDefinitionId,
      type: (eventData == null ? void 0 : eventData.alert) ? "alert" : "event"
    }),
    [alertId, resolvedDefinitionId, eventData == null ? void 0 : eventData.alert]
  );
  if (alertId && isLoadingEvent || isLoadingEventDefinition) return /* @__PURE__ */ React.createElement(Spinner, null);
  return /* @__PURE__ */ React.createElement("div", null, alertId && /* @__PURE__ */ React.createElement(ExpandableSection, { title: "Event Details" }, /* @__PURE__ */ React.createElement(
    EventDetailsTable,
    {
      event: eventData,
      meta,
      attributesList,
      attributesRenderers
    }
  )), resolvedDefinitionId && /* @__PURE__ */ React.createElement(ReplaySearchContext.Provider, { value: replaySearchContext }, /* @__PURE__ */ React.createElement(ExpandableSection, { title: "Event Definition Details" }, /* @__PURE__ */ React.createElement(EventDefinitionInfoTable, null))));
};
export default GeneralEventSideBar;
